import { useEffect, useState } from 'react'

import { useCQuery } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { showToast } from '../../../utils/toast'
import { Button, Flex, Icon, Spinner, Text } from '../..'
import { formatTime } from './Functions'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

const STATE_MAP = ['', 'not-loaded', 'started', 'success', 'SCHEDULED', 'error']
const statusColors = {
  success: 'var(--success)',
  started: 'var(--primary)',
  error: 'var(--danger)',
  'not-loaded': 'var(--ink-900)'
}
const iconStatus = { success: 'check', started: 'play', error: 'circle', 'not-loaded': 'clock' }

const getUnits = (unit) => {
  if (unit?.type === 'process') return unit?.units?.map((u) => getUnits(u))
  return [{ name: unit?.name }]
}

export const UnitsVisualizer = ({ selectedUnit = 'newMessage' }) => {
  const { data: units = [], isSuccess } = useCQuery(['units'])
  const [functions, setFunctions] = useState([])

  useEffect(() => {
    if (isSuccess) {
      const foundUnit = units.find(({ name }) => name === selectedUnit)
      setFunctions(
        getUnits(foundUnit)
          .flat(Infinity)
          .map((u) => ({ name: u.name, status: STATE_MAP[1], executionTime: 0 }))
      )
    }
  }, [units, selectedUnit])

  if (!isSuccess) return <Spinner />

  return (
    <Flex
      as
      js
      style={{
        overflowY: 'auto',
        width: 'calc(100% - 20px)',
        marginLeft: 20,
        padding: 20,
        backgroundColor: 'var(--surface-3)',
        borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--border)',
        boxShadow: 'var(--shadow-sm)'
      }}
    >
      {functions.map((data, ind) => (
        <SingleSocketData data={data} key={ind} />
      ))}
    </Flex>
  )
}

const SingleSocketData = ({ data: { name, status = '', payload = '', executionTime } }) => {
  const color = statusColors[status] || 'var(--ink-500)'
  const icon = iconStatus[status] || 'clock'

  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(payload))
    showToast('success', t.mcCopiatoNegliAppunti, t.mcPayloadCopiato)
  }

  return (
    <Flex as style={{ maxWidth: '100%' }}>
      <Flex js row style={{ maxWidth: '100%' }}>
        <Icon name={icon} size={18} style={{ marginRight: 10, marginTop: 5 }} color={color} />
        <Text size={22} value={name} color={color} />
        {(status === 'success' || status === 'error') && (
          <>
            <Text
              style={{ marginLeft: 10 }}
              size={22}
              value={formatTime(executionTime)}
              color={color}
            />
            <Button round icon="copy" onClick={copyToClipboard} style={{ marginLeft: 10 }} />
          </>
        )}
      </Flex>
    </Flex>
  )
}
